// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3052":"48e1a558","3200":"d12d1aff","7033":"de55a645","7238":"48e1a558"}[chunkId] + ".chunk.css";
};